<section
  cdkTrapFocus
  cdkTrapFocusAutoCapture
  class="tw-relative"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="accessibleName()"
>
  <div class="tw-overflow-hidden tw-rounded-xl tw-shadow-md tw-border tw-border-border-base">
    <div
      class="tw-relative tw-z-20 tw-max-w-[22.5rem] tw-break-words tw-bg-bg-primary tw-text-fg-body"
    >
      <ng-content></ng-content>
    </div>
  </div>
  <div class="bit-popover-arrow"></div>
</section>
